export enum OverrideSessionPeriodKeys {
  startAt = 'startAt',
  endAt = 'endAt',
}

export enum OverrideSessionSourceType {
  currentMaster = 'currentMaster',
  fileImport = 'fileImport',
}

export enum OverrideSessionMasterPaidImportFileKeys {
  filename = 'filename',
  mimetype = 'mimetype',
}

export enum OverrideSessionMasterPaidImportMimeType {
  xlsx = 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
}

export type OverrideSessionPeriodPayload = {
  [OverrideSessionPeriodKeys.startAt]: string;
  [OverrideSessionPeriodKeys.endAt]: string;
};

export type OverrideSessionMasterPaidCopyPayload = {
  startDate: string;
  endDate: string;
};

export type OverrideSessionMasterPaidImportPayload = {
  file: {
    [OverrideSessionMasterPaidImportFileKeys.filename]: string;
    [OverrideSessionMasterPaidImportFileKeys.mimetype]: OverrideSessionMasterPaidImportMimeType;
  };
};

export type CreateOverrideSessionPayload = {
  name: string;
  description: string | null;
  subtitle: string | null;
  period: OverrideSessionPeriodPayload | null;
};

export type UpdateOverrideSessionPayload = {
  name: string;
  description: string | null;
  subtitle: string | null;
  period: OverrideSessionPeriodPayload | null;
};
